/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST

export const createMiddleEndTask = params => {
  return axios.post(`${base}/middle-end-task/create`, params)
}

export const getMarketSalary = params => {
  return axios.get(`${base}/middle-end-task/get_market_salary_${params.marketId}`, { params })
}

export const getMiddleEndTaskBatchjob = params => {
  return axios.get(`${base}/middle-end-task/get_job_${params.id}`)
}

export const validateAvgSalary = params => {
  return axios.post(`${base}/middle-end-task/validate_avg_salary`, params)
}


export const createMiddleEndAudit = params => {
  return axios.post(`${base}/middle-end-task/create_audit`, params)
}

export const editMiddleEndAudit = params => {
  return axios.post(`${base}/middle-end-task/edit_audit_${params.id}`, params)
}

export const getMiddleEndAudit = params => {
  return axios.get(`${base}/middle-end-task/get_${params.id}`)
}

export const getMiddleEndApproveTable = params => {
  return axios.post(`${base}/middle-end-task/query_audit`, params)
}

export const editMiddleEndApproveStatus = params => {
  return axios.post(`${base}/middle-end-task/edit_status_${params.id}`, params)
}




// WEBPACK FOOTER //
// ./src/views/middle-end-task/middle-end-task.api.js